export default __webpack_public_path__ + "static/media/PostKlik.95f17f61.png";